<template>
    <div class="location-thumb" @click="activate()"  :style="{ backgroundImage: `url(`+backgroundUrl+`)` }">
        <div :class="{active: activeLocation === title}" class="py-2 lg:py-0 mb-4 lg:mb-0 bg-gray-200 lg:bg-transparent mask w-full h-full text-gray-900 lg:text-orange text-base font-bold rounded-full flex justify-center flex-wrap content-center">
            <div class="uppercase" v-text="title"></div>
        </div>
    </div>
</template>

<script>
    import {MAP} from "@/store/types/modules";
    import { mapState, mapMutations } from 'vuex'

    export default {
        props: {
            title: String,
            marker: Object,
            backgroundUrl: String
        },
        methods: {
            ...mapMutations(MAP, {
                setCenter: 'setCenter',
                setLocation: 'setLocation'
            }),
            activate() {
                this.setLocation(this.title)
                this.setCenter(this.marker)
            }
        },
        computed: {
            ...mapState(MAP, {
                activeLocation: 'activeLocation'
            })
        }

    }
</script>
<style scoped lang="scss">
    .location-thumb {
        cursor: pointer;
        background-repeat: no-repeat;
        background-size: contain;
    }

    .mask {
        transition: color 0.5s ease, background-color 0.5s ease;
        &.active {
            @apply bg-orange;
            color: #FFF;
        }
    }

</style>